import _toConsumableArray from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/regenerator/index.js";
import { proxy as u, subscribe as h, snapshot as P } from "valtio/vanilla";

var o = u({
  history: ["ConnectWallet"],
  view: "ConnectWallet",
  data: void 0
}),
    T = {
  state: o,
  subscribe: function subscribe(e) {
    return h(o, function () {
      return e(o);
    });
  },
  push: function push(e, t) {
    e !== o.view && (o.view = e, t && (o.data = t), o.history.push(e));
  },
  reset: function reset(e) {
    o.view = e, o.history = [e];
  },
  replace: function replace(e) {
    o.history.length > 1 && (o.history[o.history.length - 1] = e, o.view = e);
  },
  goBack: function goBack() {
    if (o.history.length > 1) {
      o.history.pop();

      var _o$history$slice = o.history.slice(-1),
          _o$history$slice2 = _slicedToArray(_o$history$slice, 1),
          e = _o$history$slice2[0];

      o.view = e;
    }
  },
  setData: function setData(e) {
    o.data = e;
  }
},
    a = {
  WALLETCONNECT_DEEPLINK_CHOICE: "WALLETCONNECT_DEEPLINK_CHOICE",
  WCM_VERSION: "WCM_VERSION",
  RECOMMENDED_WALLET_AMOUNT: 9,
  isMobile: function isMobile() {
    return typeof window < "u" ? Boolean(window.matchMedia("(pointer:coarse)").matches || /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/.test(navigator.userAgent)) : !1;
  },
  isAndroid: function isAndroid() {
    return a.isMobile() && navigator.userAgent.toLowerCase().includes("android");
  },
  isIos: function isIos() {
    var e = navigator.userAgent.toLowerCase();
    return a.isMobile() && (e.includes("iphone") || e.includes("ipad"));
  },
  isHttpUrl: function isHttpUrl(e) {
    return e.startsWith("http://") || e.startsWith("https://");
  },
  isArray: function isArray(e) {
    return Array.isArray(e) && e.length > 0;
  },
  formatNativeUrl: function formatNativeUrl(e, t, s) {
    if (a.isHttpUrl(e)) return this.formatUniversalUrl(e, t, s);
    var n = e;
    n.includes("://") || (n = e.replaceAll("/", "").replaceAll(":", ""), n = "".concat(n, "://")), n.endsWith("/") || (n = "".concat(n, "/")), this.setWalletConnectDeepLink(n, s);
    var i = encodeURIComponent(t);
    return "".concat(n, "wc?uri=").concat(i);
  },
  formatUniversalUrl: function formatUniversalUrl(e, t, s) {
    if (!a.isHttpUrl(e)) return this.formatNativeUrl(e, t, s);
    var n = e;
    n.endsWith("/") || (n = "".concat(n, "/")), this.setWalletConnectDeepLink(n, s);
    var i = encodeURIComponent(t);
    return "".concat(n, "wc?uri=").concat(i);
  },
  wait: function wait(e) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (t) {
                setTimeout(t, e);
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  openHref: function openHref(e, t) {
    window.open(e, t, "noreferrer noopener");
  },
  setWalletConnectDeepLink: function setWalletConnectDeepLink(e, t) {
    try {
      localStorage.setItem(a.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
        href: e,
        name: t
      }));
    } catch (_unused) {
      console.info("Unable to set WalletConnect deep link");
    }
  },
  setWalletConnectAndroidDeepLink: function setWalletConnectAndroidDeepLink(e) {
    try {
      var _e$split = e.split("?"),
          _e$split2 = _slicedToArray(_e$split, 1),
          t = _e$split2[0];

      localStorage.setItem(a.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
        href: t,
        name: "Android"
      }));
    } catch (_unused2) {
      console.info("Unable to set WalletConnect android deep link");
    }
  },
  removeWalletConnectDeepLink: function removeWalletConnectDeepLink() {
    try {
      localStorage.removeItem(a.WALLETCONNECT_DEEPLINK_CHOICE);
    } catch (_unused3) {
      console.info("Unable to remove WalletConnect deep link");
    }
  },
  setModalVersionInStorage: function setModalVersionInStorage() {
    try {
      typeof localStorage < "u" && localStorage.setItem(a.WCM_VERSION, "2.6.2");
    } catch (_unused4) {
      console.info("Unable to set Web3Modal version in storage");
    }
  },
  getWalletRouterData: function getWalletRouterData() {
    var e;
    var t = (e = T.state.data) == null ? void 0 : e.Wallet;
    if (!t) throw new Error('Missing "Wallet" view data');
    return t;
  }
},
    _ = typeof location < "u" && (location.hostname.includes("localhost") || location.protocol.includes("https")),
    r = u({
  enabled: _,
  userSessionId: "",
  events: [],
  connectedWalletId: void 0
}),
    R = {
  state: r,
  subscribe: function subscribe(e) {
    return h(r.events, function () {
      return e(P(r.events[r.events.length - 1]));
    });
  },
  initialize: function initialize() {
    r.enabled && typeof (crypto == null ? void 0 : crypto.randomUUID) < "u" && (r.userSessionId = crypto.randomUUID());
  },
  setConnectedWalletId: function setConnectedWalletId(e) {
    r.connectedWalletId = e;
  },
  click: function click(e) {
    if (r.enabled) {
      var t = {
        type: "CLICK",
        name: e.name,
        userSessionId: r.userSessionId,
        timestamp: Date.now(),
        data: e
      };
      r.events.push(t);
    }
  },
  track: function track(e) {
    if (r.enabled) {
      var t = {
        type: "TRACK",
        name: e.name,
        userSessionId: r.userSessionId,
        timestamp: Date.now(),
        data: e
      };
      r.events.push(t);
    }
  },
  view: function view(e) {
    if (r.enabled) {
      var t = {
        type: "VIEW",
        name: e.name,
        userSessionId: r.userSessionId,
        timestamp: Date.now(),
        data: e
      };
      r.events.push(t);
    }
  }
},
    c = u({
  chains: void 0,
  walletConnectUri: void 0,
  isAuth: !1,
  isCustomDesktop: !1,
  isCustomMobile: !1,
  isDataLoaded: !1,
  isUiLoaded: !1
}),
    p = {
  state: c,
  subscribe: function subscribe(e) {
    return h(c, function () {
      return e(c);
    });
  },
  setChains: function setChains(e) {
    c.chains = e;
  },
  setWalletConnectUri: function setWalletConnectUri(e) {
    c.walletConnectUri = e;
  },
  setIsCustomDesktop: function setIsCustomDesktop(e) {
    c.isCustomDesktop = e;
  },
  setIsCustomMobile: function setIsCustomMobile(e) {
    c.isCustomMobile = e;
  },
  setIsDataLoaded: function setIsDataLoaded(e) {
    c.isDataLoaded = e;
  },
  setIsUiLoaded: function setIsUiLoaded(e) {
    c.isUiLoaded = e;
  },
  setIsAuth: function setIsAuth(e) {
    c.isAuth = e;
  }
},
    W = u({
  projectId: "",
  mobileWallets: void 0,
  desktopWallets: void 0,
  walletImages: void 0,
  chains: void 0,
  enableAuthMode: !1,
  enableExplorer: !0,
  explorerExcludedWalletIds: void 0,
  explorerRecommendedWalletIds: void 0,
  termsOfServiceUrl: void 0,
  privacyPolicyUrl: void 0
}),
    y = {
  state: W,
  subscribe: function subscribe(e) {
    return h(W, function () {
      return e(W);
    });
  },
  setConfig: function setConfig(e) {
    var t, s;
    R.initialize(), p.setChains(e.chains), p.setIsAuth(Boolean(e.enableAuthMode)), p.setIsCustomMobile(Boolean((t = e.mobileWallets) == null ? void 0 : t.length)), p.setIsCustomDesktop(Boolean((s = e.desktopWallets) == null ? void 0 : s.length)), a.setModalVersionInStorage(), Object.assign(W, e);
  }
};

var V = Object.defineProperty,
    D = Object.getOwnPropertySymbols,
    H = Object.prototype.hasOwnProperty,
    B = Object.prototype.propertyIsEnumerable,
    M = function M(e, t, s) {
  return t in e ? V(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: s
  }) : e[t] = s;
},
    K = function K(e, t) {
  for (var s in t || (t = {})) {
    H.call(t, s) && M(e, s, t[s]);
  }

  if (D) {
    var _iterator = _createForOfIteratorHelper(D(t)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var s = _step.value;
        B.call(t, s) && M(e, s, t[s]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
};

var L = "https://explorer-api.walletconnect.com",
    E = "wcm",
    O = "js-2.6.2";

function w(_x, _x2) {
  return _w.apply(this, arguments);
}

function _w() {
  _w = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(e, t) {
    var s, n;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            s = K({
              sdkType: E,
              sdkVersion: O
            }, t), n = new URL(e, L);
            n.searchParams.append("projectId", y.state.projectId);
            Object.entries(s).forEach(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 2),
                  i = _ref4[0],
                  l = _ref4[1];

              l && n.searchParams.append(i, String(l));
            });
            _context9.next = 5;
            return fetch(n);

          case 5:
            return _context9.abrupt("return", _context9.sent.json());

          case 6:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _w.apply(this, arguments);
}

var m = {
  getDesktopListings: function getDesktopListings(e) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", w("/w3m/v1/getDesktopListings", e));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  getMobileListings: function getMobileListings(e) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", w("/w3m/v1/getMobileListings", e));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  getInjectedListings: function getInjectedListings(e) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", w("/w3m/v1/getInjectedListings", e));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  getAllListings: function getAllListings(e) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", w("/w3m/v1/getAllListings", e));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  getWalletImageUrl: function getWalletImageUrl(e) {
    return "".concat(L, "/w3m/v1/getWalletImage/").concat(e, "?projectId=").concat(y.state.projectId, "&sdkType=").concat(E, "&sdkVersion=").concat(O);
  },
  getAssetImageUrl: function getAssetImageUrl(e) {
    return "".concat(L, "/w3m/v1/getAssetImage/").concat(e, "?projectId=").concat(y.state.projectId, "&sdkType=").concat(E, "&sdkVersion=").concat(O);
  }
};

var z = Object.defineProperty,
    j = Object.getOwnPropertySymbols,
    J = Object.prototype.hasOwnProperty,
    q = Object.prototype.propertyIsEnumerable,
    k = function k(e, t, s) {
  return t in e ? z(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: s
  }) : e[t] = s;
},
    F = function F(e, t) {
  for (var s in t || (t = {})) {
    J.call(t, s) && k(e, s, t[s]);
  }

  if (j) {
    var _iterator2 = _createForOfIteratorHelper(j(t)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var s = _step2.value;
        q.call(t, s) && k(e, s, t[s]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return e;
};

var N = a.isMobile(),
    d = u({
  wallets: {
    listings: [],
    total: 0,
    page: 1
  },
  search: {
    listings: [],
    total: 0,
    page: 1
  },
  recomendedWallets: []
}),
    te = {
  state: d,
  getRecomendedWallets: function getRecomendedWallets() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var _y$state, e, t, s, _yield$m$getAllListin, n, i, _p$state, _s, _n, _i, l, v, _ref, b;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _y$state = y.state, e = _y$state.explorerRecommendedWalletIds, t = _y$state.explorerExcludedWalletIds;

              if (!(e === "NONE" || t === "ALL" && !e)) {
                _context6.next = 3;
                break;
              }

              return _context6.abrupt("return", d.recomendedWallets);

            case 3:
              if (!a.isArray(e)) {
                _context6.next = 13;
                break;
              }

              s = {
                recommendedIds: e.join(",")
              };
              _context6.next = 7;
              return m.getAllListings(s);

            case 7:
              _yield$m$getAllListin = _context6.sent;
              n = _yield$m$getAllListin.listings;
              i = Object.values(n);
              i.sort(function (l, v) {
                var b = e.indexOf(l.id),
                    f = e.indexOf(v.id);
                return b - f;
              }), d.recomendedWallets = i;
              _context6.next = 31;
              break;

            case 13:
              _p$state = p.state;
              _s = _p$state.chains;
              _n = _p$state.isAuth;
              _i = _s === null || _s === void 0 ? void 0 : _s.join(",");
              l = a.isArray(t);
              v = {
                page: 1,
                sdks: _n ? "auth_v1" : void 0,
                entries: a.RECOMMENDED_WALLET_AMOUNT,
                chains: _i,
                version: 2,
                excludedIds: l ? t.join(",") : void 0
              };

              if (!N) {
                _context6.next = 25;
                break;
              }

              _context6.next = 22;
              return m.getMobileListings(v);

            case 22:
              _context6.t0 = _context6.sent;
              _context6.next = 28;
              break;

            case 25:
              _context6.next = 27;
              return m.getDesktopListings(v);

            case 27:
              _context6.t0 = _context6.sent;

            case 28:
              _ref = _context6.t0;
              b = _ref.listings;
              d.recomendedWallets = Object.values(b);

            case 31:
              return _context6.abrupt("return", d.recomendedWallets);

            case 32:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },
  getWallets: function getWallets(e) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var t, _y$state2, s, n, i, l, v, _ref2, b, f, A, U;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              t = F({}, e), _y$state2 = y.state, s = _y$state2.explorerRecommendedWalletIds, n = _y$state2.explorerExcludedWalletIds, i = d.recomendedWallets;

              if (!(n === "ALL")) {
                _context7.next = 3;
                break;
              }

              return _context7.abrupt("return", d.wallets);

            case 3:
              i.length ? t.excludedIds = i.map(function (x) {
                return x.id;
              }).join(",") : a.isArray(s) && (t.excludedIds = s.join(",")), a.isArray(n) && (t.excludedIds = [t.excludedIds, n].filter(Boolean).join(",")), p.state.isAuth && (t.sdks = "auth_v1");
              l = e.page;
              v = e.search;

              if (!N) {
                _context7.next = 12;
                break;
              }

              _context7.next = 9;
              return m.getMobileListings(t);

            case 9:
              _context7.t0 = _context7.sent;
              _context7.next = 15;
              break;

            case 12:
              _context7.next = 14;
              return m.getDesktopListings(t);

            case 14:
              _context7.t0 = _context7.sent;

            case 15:
              _ref2 = _context7.t0;
              b = _ref2.listings;
              f = _ref2.total;
              A = Object.values(b);
              U = v ? "search" : "wallets";
              return _context7.abrupt("return", (d[U] = {
                listings: [].concat(_toConsumableArray(d[U].listings), _toConsumableArray(A)),
                total: f,
                page: l !== null && l !== void 0 ? l : 1
              }, {
                listings: A,
                total: f
              }));

            case 21:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },
  getWalletImageUrl: function getWalletImageUrl(e) {
    return m.getWalletImageUrl(e);
  },
  getAssetImageUrl: function getAssetImageUrl(e) {
    return m.getAssetImageUrl(e);
  },
  resetSearch: function resetSearch() {
    d.search = {
      listings: [],
      total: 0,
      page: 1
    };
  }
},
    I = u({
  open: !1
}),
    se = {
  state: I,
  subscribe: function subscribe(e) {
    return h(I, function () {
      return e(I);
    });
  },
  open: function open(e) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", new Promise(function (t) {
                var _p$state2 = p.state,
                    s = _p$state2.isUiLoaded,
                    n = _p$state2.isDataLoaded;
                if (a.removeWalletConnectDeepLink(), p.setWalletConnectUri(e === null || e === void 0 ? void 0 : e.uri), p.setChains(e === null || e === void 0 ? void 0 : e.chains), T.reset("ConnectWallet"), s && n) I.open = !0, t();else {
                  var i = setInterval(function () {
                    var l = p.state;
                    l.isUiLoaded && l.isDataLoaded && (clearInterval(i), I.open = !0, t());
                  }, 200);
                }
              }));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }))();
  },
  close: function close() {
    I.open = !1;
  }
};

var G = Object.defineProperty,
    $ = Object.getOwnPropertySymbols,
    Q = Object.prototype.hasOwnProperty,
    X = Object.prototype.propertyIsEnumerable,
    S = function S(e, t, s) {
  return t in e ? G(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: s
  }) : e[t] = s;
},
    Y = function Y(e, t) {
  for (var s in t || (t = {})) {
    Q.call(t, s) && S(e, s, t[s]);
  }

  if ($) {
    var _iterator3 = _createForOfIteratorHelper($(t)),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var s = _step3.value;
        X.call(t, s) && S(e, s, t[s]);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return e;
};

function Z() {
  return typeof matchMedia < "u" && matchMedia("(prefers-color-scheme: dark)").matches;
}

var C = u({
  themeMode: Z() ? "dark" : "light"
}),
    ne = {
  state: C,
  subscribe: function subscribe(e) {
    return h(C, function () {
      return e(C);
    });
  },
  setThemeConfig: function setThemeConfig(e) {
    var t = e.themeMode,
        s = e.themeVariables;
    t && (C.themeMode = t), s && (C.themeVariables = Y({}, s));
  }
},
    g = u({
  open: !1,
  message: "",
  variant: "success"
}),
    oe = {
  state: g,
  subscribe: function subscribe(e) {
    return h(g, function () {
      return e(g);
    });
  },
  openToast: function openToast(e, t) {
    g.open = !0, g.message = e, g.variant = t;
  },
  closeToast: function closeToast() {
    g.open = !1;
  }
};
export { y as ConfigCtrl, a as CoreUtil, R as EventsCtrl, te as ExplorerCtrl, se as ModalCtrl, p as OptionsCtrl, T as RouterCtrl, ne as ThemeCtrl, oe as ToastCtrl };